import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const Index = { auth: authRoles.admin, routes: [{ path: '/pickups-processor/:date?', component: FuseLoadable({ loader: () => import('./PickupsProcessorApp') }) }] };

export default [Index];
